var alignmentStyle = {"alignLeft":"lef-e","textWrapNowrap":"ZWKEO","alignRight":"P0puD","alignCenter":"_1e-ta","sizeFullWidth":"g5VGC","renderedInTable":"kVM8j","sizeOriginal":"V3Bmq","sizeContent":"HhmWE","sizeSmall":"O5G0u","sizeSmallCenter":"aWEPq","flex":"rpN-N","LEFT":"xTWT2","CENTER":"gqZVI","RIGHT":"_8z7P7","AUTO":"HbsNx","JUSTIFY":"dB12f"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-662602d5.js.map
